<app-pillar
  [bannerUrl]="'assets/images/pages/home/pro-sup-banner.webp'"
  [bannerMobUrl]="'assets/images/pages/home/pro-sup-banner-mob.webp'"
  [introText]="
    '<b>PRO:SUPPORT</b> to stawianie Twojego salonu w centrum. Specjalne, indywidualnie dobrane oferty produktowe i atrakcyjne nagrody, które pomogą Ci osiągnąć sukces. Zyskaj dostęp do ekskluzywnych zniżek i ciesz się wsparciem, na które zasługujesz, dzięki PRO:SUPPORT!'
  "
  [tiles]="[]"
  [slides]="['assets/images/pages/home/sup-1', 'assets/images/pages/home/sup-2', 'assets/images/pages/home/sup-3']"
/>
